

// export const getModule = (id) => MODULES.find(m => m.id === id) || MODULES[0];
// export const enabledModules = () => MODULES.filter(m => m.enabled);
// export const comingSoonModules = () => MODULES.filter(m => !m.enabled);

// ─────────────────────────────────────────────────────────────
// MODULE REGISTRY
// Add new modules here — app auto-picks theme, nav, routes
// ─────────────────────────────────────────────────────────────

export const MODULES = [
  {
    id:          'agri',
    name:        'Crops',
    tagline:     'Fresh. Direct. Trusted.',
   icon: '/crops.png',
    color:       '#1A6B3C',
    colorHover:  '#155530',
    colorLight:  '#E8F5EE',
    colorMid:    '#4CAF7D',
    bodyAttr:    'agri',
    searchPlaceholder: 'Search crops or farmers...',
    phase:       1,
    enabled:     true,
    banner: {
      headline:  'Farm to Market, Direct',
      sub:       'Buy fresh crops from farmers near you',
      emoji:     '/crops.png',
      cta:       'Browse Crops',
      ctaPath:   '/marketplace',
    },
    nav: [
      { path:'/',              icon:'🏠', label:'Home'     },
      { path:'/marketplace',   icon:'🛒', label:'Market'   },
      { path:'/add-crop',      icon:null, label:'Add', isAdd:true },
      { path:'/requests/incoming', icon:'📥', label:'Requests' },
      { path:'/profile',       icon:'👤', label:'Profile'  },
    ],
  },
  {
    id:          'nursery',
    name:        'Nursery',
    tagline:     'Plants for every space',
    icon: '/nursery.png',
    color:       '#4D7C0F',
    colorHover:  '#3A5F0B',
    colorLight:  '#F7FEE7',
    colorMid:    '#84CC16',
    bodyAttr:    'nursery',
    searchPlaceholder: 'Search plants, seeds, pots...',
    phase:       2,
    enabled:     true,
    banner: {
      headline:  'Fresh plants delivered',
      sub:       'Indoor, outdoor & rare plants',
      emoji:     '🪴',
      cta:       'Shop Plants',
      ctaPath:   '/nursery',
    },
    nav: [
      { path:'/nursery',          icon:'🏠', label:'Home'    },
      { path:'/nursery/catalog',  icon:'', label:'Catalog' },
      // { path:'/nursery/cart',     icon:null, label:'Cart', isAdd:true },
      { path:'/nursery/orders',   icon:'📦', label:'Orders'  },
      { path:'/profile',          icon:'👤', label:'Profile' },
    ],
  },
//   {
//   id:          'land',
//   name:        'Land',
//   tagline:     'Buy & lease farmland',
//   icon:        '/images/land.jpg',
//   color:       '#166534',
//   colorHover:  '#14532D',
//   colorLight:  '#DCFCE7',
//   colorMid:    '#22C55E',
//   bodyAttr:    'land',
//   searchPlaceholder: 'Search land, plots, farms...',
//   phase:       4,
//   enabled:     true,
//   banner: {
//     headline:  'Find your farmland',
//     sub:       'Verified listings near you',
//     emoji:     '🗺️',
//     cta:       'Browse Land',
//     ctaPath:   '/land',
//   },
//   nav: [
//     { path:'/land',              icon:'🏠', label:'Home'         },
//     { path:'/land/my-listings',  icon:'📋', label:'My Listings'  },
//     { path:'/land/add',          icon:null, label:'Add Property', isAdd:true },
//     { path:'/land/messages',     icon:'💬', label:'Messages'     },
//     { path:'/profile',           icon:'👤', label:'Profile'      },
//   ],
// },
  // {
  //   id:          'organic',
  //   name:        'Organic',
  //   tagline:     'Certified. Pure. Healthy.',
  //   icon:        '',
  //   color:       '#065F46',
  //   colorHover:  '#064E3B',
  //   colorLight:  '#ECFDF5',
  //   colorMid:    '#34D399',
  //   bodyAttr:    'organic',
  //   searchPlaceholder: 'Search certified organic...',
  //   phase:       3,
  //   enabled:     false,
  //   banner: {
  //     headline:  '100% certified organic',
  //     sub:       'Traceable from farm to fork',
  //     emoji:     '',
  //     cta:       'Coming soon',
  //     ctaPath:   '/',
  //   },
  //   nav: [],
  // },
  // {
  //   id:          'ecommerce',
  //   name:        'Shop',
  //   tagline:     'Best deals on agri products',
  //   icon:        '🛒',
  //   color:       '#4338CA',
  //   colorHover:  '#3730A3',
  //   colorLight:  '#EEF2FF',
  //   colorMid:    '#818CF8',
  //   bodyAttr:    'ecommerce',
  //   searchPlaceholder: 'Search products...',
  //   phase:       3,
  //   enabled:     false,
  //   banner: {
  //     headline:  'Great deals today',
  //     sub:       'Fresh agri products online',
  //     emoji:     '🎁',
  //     cta:       'Coming soon',
  //     ctaPath:   '/',
  //   },
  //   nav: [],
  // },
];

export const getModule = (id) => MODULES.find(m => m.id === id) || MODULES[0];
export const enabledModules = () => MODULES.filter(m => m.enabled);
export const comingSoonModules = () => MODULES.filter(m => !m.enabled);